// extracted by mini-css-extract-plugin
export default {"organizationsContainer":"_organizations-page_organizationsContainer__kPauB"};